export function getProducts(){
    var products = JSON.parse(localStorage.getItem("products"))
    console.log("helper getProducts")
    return(products)
}

export function reduceQTY(barcode, qty){
    console.log("this should reduce the stock itemsin product by 1 when an itemis added to the shopping list currentShop ready for checkout")
}

export function increaseQTY(barcode, qty){
    console.log("this should increase the product amount when an item is removed from basket ofcurrentShop")
}
export function addItemToShopping(barcode){
    console.log("This should increase the currentShop when an item is scanned using input box")
}

export function addShopToSalesTotal(shopping){
    console.log("this should add items from currentShop or similar to a SalesLedger and clear currentShop local storage reset state");
}

export function cashOut(amount){
    //this is a function to adjust the cash held in the draw.
}